import { NavBarAccessModel } from '@/types';
import { CustomerRouteConstants } from './constants/RouteConstants';
import { ToolsModel } from '@/services/GeneratedApi';

// This will override all instances of the text 'mstore' in the app
export const CustomerAppName = '';

export const Components = {
  TaskServices: {},
  WorkflowJob: {},
  WorkflowQueue: {},
  BuiltInListItem: {},
  VerticalWorkflowJobTabs: {},
  CustomIndexingLookup: {}
};

export const Routes = [];

export const NavbarItems: Array<{
  routeName: string;
  hasAccess: (navbarAccess?: NavBarAccessModel) => boolean;
  text: string;
  order?: number;
}> = [];

export const getToolsTreeNodes = (toolsModel: ToolsModel) => [];
